module.exports = __webpack_public_path__ + "static/img/icon-3.8bbf277.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon-3.png
// module id = 9wfQ
// module chunks = 1